import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './historicinteriors.css'; // Import the CSS file for styling

const HistoricInteriors = () => {
    // Array of image paths for the slideshow
    const imagePaths = [
"/images/Historic Interiors/Hist Interiors_01.jpg",
"/images/Historic Interiors/Hist Interiors_02.jpg",
"/images/Historic Interiors/Hist Interiors_03.jpg",
"/images/Historic Interiors/Hist Interiors_04.jpg",
"/images/Historic Interiors/Hist Interiors_05.jpg",
"/images/Historic Interiors/Hist Interiors_06.jpg",
"/images/Historic Interiors/Hist Interiors_07.jpg",
"/images/Historic Interiors/Hist Interiors_08.jpg",
"/images/Historic Interiors/Hist Interiors_09.jpg",
"/images/Historic Interiors/Hist Interiors_10.jpg",
"/images/Historic Interiors/Hist Interiors_11.jpg",
"/images/Historic Interiors/Hist Interiors_12.jpg",
"/images/Historic Interiors/Hist Interiors_13.jpg",
"/images/Historic Interiors/Hist Interiors_14.jpg",
"/images/Historic Interiors/Hist Interiors_15.jpg",
"/images/Historic Interiors/Hist Interiors_16.jpg",
"/images/Historic Interiors/Hist Interiors_17.jpg",
"/images/Historic Interiors/Hist Interiors_18.jpg",
"/images/Historic Interiors/Hist Interiors_19.jpg",
"/images/Historic Interiors/Hist Interiors_20.jpg",
"/images/Historic Interiors/Hist Interiors_21.jpg",
"/images/Historic Interiors/Hist Interiors_22.jpg",
"/images/Historic Interiors/Hist Interiors_23.jpg",
"/images/Historic Interiors/Hist Interiors_24.jpg",
"/images/Historic Interiors/Hist Interiors_25.jpg",
"/images/Historic Interiors/Hist Interiors_26.jpg",
"/images/Historic Interiors/Hist Interiors_27.jpg",
"/images/Historic Interiors/Hist Interiors_28.jpg",
"/images/Historic Interiors/Hist Interiors_29.jpg",
"/images/Historic Interiors/Hist Interiors_30.jpg",
"/images/Historic Interiors/Hist Interiors_31.jpg",
"/images/Historic Interiors/Hist Interiors_32.jpg",
"/images/Historic Interiors/Hist Interiors_33.jpg",
"/images/Historic Interiors/Hist Interiors_34.jpg",
"/images/Historic Interiors/Hist Interiors_35.jpg",
"/images/Historic Interiors/Hist Interiors_36.jpg",
"/images/Historic Interiors/Hist Interiors_37.jpg",
"/images/Historic Interiors/Hist Interiors_38.jpg"


    ];

    // State to track the current image index
    const [currentIndex, setCurrentIndex] = useState(0);

    // Function to go to the next image in the array
    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imagePaths.length);
    };

    // Function to go to the previous image in the array
    const prevImage = () => {
        setCurrentIndex(
            (prevIndex) => (prevIndex - 1 + imagePaths.length) % imagePaths.length
        );
    };

    return (
        <div className="historicinteriors-container">
            {/* Home button */}
            <Link to="/" className="home-button">Home</Link>

            <div className="image-frame">
                <div className="text-container">
                    <h2>
                        {/* Title */}
                        <div className="title-gc">Historic Interiors</div>
                    </h2>
                    <p>
                        <div className="text-blurb">
                            Installation/deinstallation, moving, conservation, and documentation of period rooms and other historic interiors for museums, private clubs, religious organizations, and municipal buildings.
                        </div>
                    </p>
                </div>

                <div className="slideshow-container">
                    <img
                        src={imagePaths[currentIndex]}
                        alt={`Historic Interior ${currentIndex + 1}`}
                        className="historicinteriors-image"
                    />

                    {/* Navigation buttons */}
                    <button className="prev-button" onClick={prevImage}>❮</button>
                    <button className="next-button" onClick={nextImage}>❯</button>
                </div>
            </div>
        </div>
    );
};

export default HistoricInteriors;
